<template>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submit)">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-green">
            <div class="card-icon">
              <md-icon>bookmark</md-icon>
            </div>
            <h4 class="title">任务资源</h4>
          </md-card-header>
          <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item md-size-90 mx-auto">
                <v-expansion-panels flat="true" focusable v-model="panel">
                  <v-expansion-panel key="base">
                
                    <v-expansion-panel-content style="margin-top:15px">
                      <!-- <v-text-field v-model="form.name" label="课程名称 *" :rules="[(v) => !!v || '课程名称不能为空']"></v-text-field> -->
                      <v-select v-model="form.sectionType" :items="sectionType" item-text="name" item-value="value"
                        label="课程名称 *"></v-select>
                        <v-select v-model="form.sectionType" :items="sectionType" item-text="name" item-value="value"
                        label="实训名称 *"></v-select>
                      <!-- <v-textarea v-model="form.description" label="课程简介" rows="1" auto-grow
                        :rules="[(v) => !!v || '课程简介不能为空']"></v-textarea> -->
                      <md-field>
                        <label>相关资料</label><md-file v-model="form.attachment_url"  @change="fileChange" />
                        <!-- <span class="md-helper-text"> 可上传多个文件</span> -->
                      </md-field>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                
               
                </v-expansion-panels>
                <md-card-actions md-alignment="right">
                  <md-button class="md-success md-sm" type="submit">确定</md-button>
                  <md-button class="md-success md-sm" @click="toCourse">返回</md-button>
                </md-card-actions>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </form>
    </ValidationObserver>
  </template>
  
  <script>
  import { addCourse, updateCourse } from "@/api/course";
  
  import { SlideYDownTransition } from "vue2-transitions";
  import { extend } from "vee-validate";
  import { required } from "vee-validate/dist/rules";
  
  extend("required", required);
  
  export default {
    //mixins: [validationMixin],
    components: {
      SlideYDownTransition,
    },
    data() {
      return {
        panel: 0,
        sectionType: [
          { value: "zj", name: "章节" },
          { value: "xm", name: "项目" },
        ],
       
        majorGroupList: [],
        majorGroup2List: [],
        majorList: [],
        form: {
          required: "",
          name: "",
          university: "",
          college: "",
          refer: [],
          major: "",
          majorGroup: "",
          majorGroup2: "",
          team: "",
  
          manager: "",
          attachment_url: "",
          description: "",
        },
      };
    },
    watch: {
      'form.refer'() {
        const refer = Array.isArray(this.form.refer) ? this.form.refer.join(',') : this.form.refer
        if (!refer) return;
        this.majorGroupList = []
        this.majorGroup2List = []
        this.majorList = []
        this.$dic.getCategoryList(
          {
            cate_type: refer,
            level: '1'
          },
          (data) => {
            this.majorGroupList = data
          }
        )
      },
      'form.majorGroup'() {
        if (!this.form.majorGroup) return;
        this.majorGroup2List = []
        this.majorList = []
        this.$dic.getCategoryList(
          {
            cate_type: this.form.refer,
            parentCode: this.form.majorGroup,
            level: '2'
          },
          (data) => {
            this.majorGroup2List = data
          }
        )
      },
      'form.majorGroup2'() {
        if (!this.form.majorGroup2) return;
        this.majorList = []
        this.$dic.getCategoryList(
          {
            cate_type: this.form.refer,
            parentCode: this.form.majorGroup2,
            level: '3'
          },
          (data) => {
            this.majorList = data
          }
        )
      },
    },
    mounted() {
      this.init();
    },
    methods: {
      async fileChange(e) {
        console.log("更改文件", e);
      },
      async init() {
        if (this.$route.query.name) this.form = this.$route.query;
      },
      async submit() {
        //this.$v.$touch();
        //if (!this.$v.$invalid) {
        const result = this.form._id
          ? await updateCourse(this.form)
          : await addCourse(this.form);
        if (result.code == 200) {
          this.$notify({
            timeout: 1500,
            message: "操作成功！",
            icon: "add_alert",
            horizontalAlign: "center",
            verticalAlign: "bottom",
            type: "success",
          });
  
          this.$router.push({ path: "./resources" });
        }
        //} else {
        //  Swal.fire("提示!", "请填写必填项!", "warning");
        //}
      },
      toCourse() {
        this.$router.push({ path: "./resources" });
      },
    },
  };
  </script>
  
  <style lang="css" scoped>
  .md-card .md-card-actions {
    border: 0;
    margin-left: 20px;
    margin-right: 20px;
  }
  </style>